import { fetchBackend } from './apiClient';

export const refreshStateAndCloud = async (
  projectId: string,
): Promise<void> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 600_000);

  try {
    const response = await fetchBackend(
      `/refresh-graph/time-machine/state-and-cloud`,
      {
        method: 'POST',
        body: JSON.stringify({ project_id: projectId, refresh_all: true }),
        signal: controller.signal,
        keepalive: true,
      },
    );
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
  } catch (error) {
    if ((error as { name: string }).name === 'AbortError') {
      throw new Error('Request timed out');
    }

    throw error;
  }
};

export const regenerateTimeMachine = async (
  projectId: string,
): Promise<void> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 3_600_000);

  try {
    const response = await fetchBackend(
      `/refresh-graph/time-machine/regenerate`,
      {
        method: 'POST',
        body: JSON.stringify({ project_id: projectId }),
        signal: controller.signal,
        keepalive: true,
      },
    );
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
  } catch (error) {
    if ((error as { name: string }).name === 'AbortError') {
      throw new Error('Request timed out');
    }

    throw error;
  }
};
